
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'active': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.5C0 2.91038 2.91038 0 6.5 0C10.0896 0 13 2.91038 13 6.5C13 10.0896 10.0896 13 6.5 13C2.91038 13 0 10.0896 0 6.5ZM6.03796 9.35296L10.133 5.25796C10.3447 5.04617 10.3447 4.70383 10.133 4.49204C9.92117 4.28025 9.57883 4.28025 9.36704 4.49204L5.655 8.20408L4.16758 6.71667C3.95579 6.50488 3.61346 6.50488 3.40167 6.71667C3.18987 6.92846 3.18987 7.27079 3.40167 7.48258L5.27204 9.35296C5.37333 9.45479 5.51146 9.51167 5.655 9.51167C5.79854 9.51167 5.93613 9.45479 6.03796 9.35296Z" fill="white"/>'
  }
})
